import { comparisonFiltersEntitySchema } from '#shared/projects.filters.model.js';
import { z } from 'zod';
const comparisonEntitySchema = z.object({
    id: z.number(),
    comparisonFilters: comparisonFiltersEntitySchema
});
export { comparisonEntitySchema };
//# sourceMappingURL=projects.comparison.model.js.map